import React from "react";
import { User, Briefcase, Award, CheckCircle2 } from "lucide-react";

interface ProgressStepsProps {
  currentStep: number;
}

export const ProgressSteps = ({ currentStep }: ProgressStepsProps) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div className="flex flex-col items-center">
          <div
            className={`h-10 w-10 rounded-full border-2 flex items-center justify-center ${
              currentStep >= 1 ? "border-emerald-500 bg-emerald-50" : "border-gray-300"
            }`}
          >
            <User
              className={`h-5 w-5 ${currentStep >= 1 ? "text-emerald-500" : "text-gray-400"}`}
            />
          </div>
          <p
            className={`text-xs mt-1 ${
              currentStep >= 1 ? "text-emerald-500 font-medium" : "text-gray-500"
            }`}
          >
            Personal
          </p>
        </div>

        <div
          className={`h-1 flex-1 mx-2 ${currentStep >= 2 ? "bg-emerald-500" : "bg-gray-200"}`}
        />

        <div className="flex flex-col items-center">
          <div
            className={`h-10 w-10 rounded-full border-2 flex items-center justify-center ${
              currentStep >= 2 ? "border-emerald-500 bg-emerald-50" : "border-gray-300"
            }`}
          >
            <Briefcase
              className={`h-5 w-5 ${currentStep >= 2 ? "text-emerald-500" : "text-gray-400"}`}
            />
          </div>
          <p
            className={`text-xs mt-1 ${
              currentStep >= 2 ? "text-emerald-500 font-medium" : "text-gray-500"
            }`}
          >
            Professional
          </p>
        </div>

        <div
          className={`h-1 flex-1 mx-2 ${currentStep >= 3 ? "bg-emerald-500" : "bg-gray-200"}`}
        />

        <div className="flex flex-col items-center">
          <div
            className={`h-10 w-10 rounded-full border-2 flex items-center justify-center ${
              currentStep >= 3 ? "border-emerald-500 bg-emerald-50" : "border-gray-300"
            }`}
          >
            <Award
              className={`h-5 w-5 ${currentStep >= 3 ? "text-emerald-500" : "text-gray-400"}`}
            />
          </div>
          <p
            className={`text-xs mt-1 ${
              currentStep >= 3 ? "text-emerald-500 font-medium" : "text-gray-500"
            }`}
          >
            Skills
          </p>
        </div>

        {/* <div
          className={`h-1 flex-1 mx-2 ${currentStep >= 4 ? "bg-emerald-500" : "bg-gray-200"}`}
        />

        <div className="flex flex-col items-center">
          <div
            className={`h-10 w-10 rounded-full border-2 flex items-center justify-center ${
              currentStep >= 4 ? "border-emerald-500 bg-emerald-50" : "border-gray-300"
            }`}
          >
            <CheckCircle2
              className={`h-5 w-5 ${currentStep >= 4 ? "text-emerald-500" : "text-gray-400"}`}
            />
          </div>
          <p
            className={`text-xs mt-1 ${
              currentStep >= 4 ? "text-emerald-500 font-medium" : "text-gray-500"
            }`}
          >
            Review
          </p>
        </div> */}
      </div>
    </div>
  );
};